import { CircularProgress } from "@material-ui/core";
import Button, { ButtonProps } from "@material-ui/core/Button";
import useText from "constants/text";
import React from "react";

interface IUploadButtonInputProps extends ButtonProps {
  accept: string;
  onChangeInput: (e: any, loaderFunction: any) => void;
}
export function UploadButtonInput({ accept, onChangeInput, ...props }: IUploadButtonInputProps) {
  const [isloading, setIsloading] = React.useState(false);
  const { text } = useText();
  const ref = React.useRef(null);
  return (
    <>
      <input
        ref={ref}
        accept={accept}
        style={{ display: "none" }}
        id="upload-parcel-button"
        type="file"
        onChange={(e) => onChangeInput(e, setIsloading)}
      />
      <label htmlFor="upload-parcel-button">
        <Button component="span" {...props}>
          {isloading ? <CircularProgress /> : `${text.all.upload_template}`}
        </Button>
      </label>
    </>
  );
}
